/**
 * talk·point — Warenkorb-Zubehör-Modal (v1)
 * ---------------------------------------------------------------------------
 * Port des alten Themes (tp-addon-modal), angebunden an die Horizon-Cart-Mechanik.
 *
 * Idee: Horizon legt das Hauptprodukt normal in den Warenkorb (product-form-component,
 * aktualisiert Badge + Drawer-Inhalt nativ). Wir unterdrücken nur das Auto-Öffnen des
 * Drawers (auto-open-Attribut entfernen) und zeigen stattdessen ein Modal mit passendem
 * Zubehör. Kein Eingriff in Horizon-Core.
 *
 * Trigger bewusst OHNE Abhängigkeit vom internen Event-Namen: Beim Submit der
 * Add-to-cart-Form merken wir uns den aktuellen Warenkorb-Stand (Badge) und pollen
 * danach /cart.js, bis die Menge steigt (= Add erfolgreich). Schlägt der Add fehl
 * (Validierung, ausverkauft), steigt nichts -> kein Modal.
 *
 * Datenquelle: Produkte mit Tag BasenameAccessory_<basename> per Storefront-GraphQL.
 * Token/Version aus den Theme-Settings (Data-Attribute am Root). Bewusst import-frei.
 */
(function () {
  if (window.__tpAddonModalInit) return;
  window.__tpAddonModalInit = true;

  var root = document.getElementById('tp-addon-modal');
  if (!root) return;

  var BASENAME = root.dataset.basename;
  var CART_URL = root.dataset.cartUrl || '/cart';
  var GQL_TOKEN = root.dataset.token;
  var API_VERSION = root.dataset.apiVersion || '2025-07';
  var GQL_URL = '/api/' + API_VERSION + '/graphql.json';
  var MAX_ITEMS = parseInt(root.dataset.max, 10) || 12;

  if (!BASENAME || !GQL_TOKEN) return;

  var bodyEl = root.querySelector('[data-tpam-body]');
  var countEl = root.querySelector('[data-tpam-count]');

  /* ---------- v1: Drawer-Auto-Open unterdrücken (additiv, kein Core-Eingriff) ----------
     <cart-drawer-component auto-open> öffnet den Drawer bei jedem Add. Wir entfernen
     das Attribut -> Horizon aktualisiert Badge + Drawer-Inhalt weiterhin, aber der
     Drawer springt nicht auf; unser Modal übernimmt die Bestätigung. */
  var cartDrawerComp = document.querySelector('cart-drawer-component');
  if (cartDrawerComp) cartDrawerComp.removeAttribute('auto-open');

  /* ---------- Helfer ---------- */
  function money(amount, currency) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR' }).format(
        parseFloat(amount)
      );
    } catch (e) {
      return amount + ' ' + (currency || '');
    }
  }
  function gidToId(gid) {
    return (gid || '').split('/').pop();
  }
  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }
  function conditionLabel(tags) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].indexOf('Zustand_') === 0) {
        var parts = tags[i].split(' - ');
        if (parts.length > 1) return parts[1].charAt(0).toUpperCase() + parts[1].slice(1);
      }
    }
    return null;
  }

  // Line-Item-Property "Zustand" (IT#16397) aus dem Tag "Zustand_A - Wie Neu";
  // gleiches Wording wie snippets/tp-condition-label.liquid. Neuware -> null.
  // (Storefront-GraphQL liefert keine Metafields ohne Deklaration, darum Tag.)
  function conditionProperty(tags) {
    for (var i = 0; i < tags.length; i++) {
      if (tags[i].indexOf('Zustand_') === 0) {
        var val = tags[i].slice(8);
        // CPO-Neuware (Plan 0126) stempelt „Neu · CPO" wie snippets/tp-condition-label.liquid.
        if (val === 'Neuware') return tags.indexOf('CPO') !== -1 ? 'Neu · CPO' : null;
        var parts = val.split(' - ');
        return 'B-Ware – ' + parts[0] + (parts[1] ? ' (' + parts[1].toLowerCase() + ')' : '');
      }
    }
    return null;
  }

  /* ---------- Zubehör vorab laden (Storefront GraphQL, gleicher Weg wie Varianten-Selector) ---------- */
  var offersReady = false;
  var offers = [];
  var offersPromise = (function () {
    var query =
      'query getAddons($query: String!, $first: Int!) {' +
      '  products(first: $first, query: $query) {' +
      '    edges { node {' +
      '      id title handle vendor tags productType' +
      '      featuredImage { url(transform: {maxWidth: 200, maxHeight: 200, crop: CENTER}) }' +
      '      priceRange { minVariantPrice { amount currencyCode } }' +
      '      compareAtPriceRange { minVariantPrice { amount currencyCode } }' +
      '      variants(first: 1) { edges { node { id availableForSale } } }' +
      '    }}' +
      '  }' +
      '}';
    return fetch(GQL_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': GQL_TOKEN },
      body: JSON.stringify({
        query: query,
        variables: { query: 'tag:BasenameAccessory_' + BASENAME + ' AND available_for_sale:true', first: 100 }
      })
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        var edges = (data && data.data && data.data.products && data.data.products.edges) || [];
        offers = edges
          .filter(function (e) {
            return e.node.tags.indexOf('BasenameAccessory_' + BASENAME) !== -1;
          })
          .map(function (e) {
            var n = e.node;
            var v = n.variants.edges[0] && n.variants.edges[0].node;
            var price = n.priceRange.minVariantPrice;
            var cmp = n.compareAtPriceRange && n.compareAtPriceRange.minVariantPrice;
            var hasCmp = cmp && parseFloat(cmp.amount) > parseFloat(price.amount);
            return {
              variantId: v ? gidToId(v.id) : null,
              available: v ? v.availableForSale : false,
              title: n.title,
              handle: n.handle,
              vendor: n.vendor || '',
              productType: n.productType || '',
              image: n.featuredImage ? n.featuredImage.url : '',
              price: money(price.amount, price.currencyCode),
              compareAt: hasCmp ? money(cmp.amount, cmp.currencyCode) : null,
              condition: conditionLabel(n.tags),
              conditionProp: conditionProperty(n.tags)
            };
          })
          .filter(function (o) {
            return o.variantId && o.available;
          })
          .slice(0, MAX_ITEMS);
        offersReady = true;
        return offers;
      })
      .catch(function (err) {
        console.error('[tpam] Zubehör-Fetch fehlgeschlagen:', err);
        offersReady = true;
        offers = [];
        return offers;
      });
  })();

  /* ---------- Render ---------- */
  function renderCard(o) {
    var href = '/products/' + encodeURIComponent(o.handle);
    var img = o.image ? '<img src="' + esc(o.image) + '" alt="' + esc(o.title) + '" loading="lazy">' : '';
    var cond = o.condition ? '<span class="tpam-card__cond">' + esc(o.condition) + '</span>' : '';
    var old = o.compareAt ? '<span class="tpam-card__old">' + o.compareAt + '</span>' : '';
    var vendor = o.vendor ? '<span class="tpam-card__vendor">' + esc(o.vendor) + '</span>' : '';
    return (
      '<div class="tpam-card" data-type="' +
      esc(o.productType || '') +
      '">' +
      cond +
      '<a class="tpam-card__img" href="' +
      href +
      '">' +
      img +
      '</a>' +
      '<div class="tpam-card__price">' +
      o.price +
      old +
      '</div>' +
      '<a class="tpam-card__name" href="' +
      href +
      '">' +
      esc(o.title) +
      '</a>' +
      vendor +
      '<button type="button" class="tpam-card__add" data-tpam-add data-variant-id="' +
      esc(o.variantId) +
      '"' +
      (o.conditionProp ? ' data-condition-prop="' + esc(o.conditionProp) + '"' : '') +
      '>+ Hinzufügen</button>' +
      '</div>'
    );
  }

  function renderFilter(list) {
    var types = [];
    list.forEach(function (o) {
      if (o.productType && types.indexOf(o.productType) === -1) types.push(o.productType);
    });
    if (types.length < 2) return '';
    return (
      '<div class="tpam-filter">' +
      '<button type="button" class="tpam-filter__btn is-active" data-tpam-filter="all">Alle</button>' +
      types
        .map(function (t) {
          return '<button type="button" class="tpam-filter__btn" data-tpam-filter="' + esc(t) + '">' + esc(t) + '</button>';
        })
        .join('') +
      '</div>'
    );
  }

  function fillModal(list) {
    bodyEl.innerHTML =
      '<div class="tpam-block">' +
      '<h4 class="tpam-block__h">Passendes Zubehör</h4>' +
      '<p class="tpam-block__s">Sicher kompatibel – von Kund:innen oft zusammen gekauft.</p>' +
      renderFilter(list) +
      '<div class="tpam-grid">' +
      list.map(renderCard).join('') +
      '</div>' +
      '</div>';
  }

  /* ---------- Öffnen / Schließen ---------- */
  var lastFocus = null;
  function openModal() {
    lastFocus = document.activeElement;
    root.hidden = false;
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCount();
  }
  function closeModal() {
    root.hidden = true;
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) {
      try {
        lastFocus.focus();
      } catch (e) {}
    }
  }
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-tpam-close]')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) closeModal();
  });

  /* ---------- Fallback: Drawer nativ öffnen (kein Zubehör -> kein „nichts passiert") ---------- */
  function openDrawerFallback() {
    var drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      try {
        drawer.open();
        return;
      } catch (e) {}
    }
    // Letzter Ausweg: zur Warenkorb-Seite
    // (nur wenn der Drawer partout nicht ansprechbar ist)
  }

  /* ---------- Warenkorb-Badge (Horizon .cart-bubble) aktualisieren ---------- */
  function updateBadge(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (bubble) {
      bubble.classList.toggle('visually-hidden', count <= 0);
      var c = bubble.querySelector('.cart-bubble__text-count');
      if (c) {
        c.textContent = count > 0 ? count : '';
        c.classList.toggle('hidden', count <= 0);
      }
    });
  }
  function refreshCount() {
    return fetch(CART_URL + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        updateBadge(cart.item_count);
        if (countEl) countEl.textContent = cart.item_count > 0 ? '(' + cart.item_count + ')' : '';
        return cart;
      })
      .catch(function () {});
  }

  /* ---------- Drawer-Inhalt nach eigenem Quick-Add nachziehen (Section Rendering API) ----------
     Eigene /cart/add.js-Aufrufe lösen kein Horizon-Cart-Event aus, der Drawer morpht also
     nicht selbst. Wir holen NUR die Cart-Drawer-Section neu (leichtgewichtig) und ersetzen
     .cart-drawer__inner. Saubere URL ohne weitere Query-Params (die lösen 404 aus). */
  var drawerRefreshTimer = null;
  function refreshDrawerSection() {
    clearTimeout(drawerRefreshTimer);
    drawerRefreshTimer = setTimeout(function () {
      fetch(window.location.pathname + '?section_id=cart-drawer-section', { cache: 'no-store' })
        .then(function (r) {
          return r.ok ? r.text() : Promise.reject();
        })
        .then(function (html) {
          if (!html) return;
          var frag = new DOMParser().parseFromString(html, 'text/html');
          var fresh = frag.querySelector('.cart-drawer__inner');
          var live = document.querySelector('#cart-drawer .cart-drawer__inner');
          if (fresh && live) live.replaceWith(fresh);
        })
        .catch(function () {});
    }, 300);
  }

  /* ---------- Body-Klicks: Filter + Quick-Add ---------- */
  bodyEl.addEventListener('click', function (e) {
    var fbtn = e.target.closest('[data-tpam-filter]');
    if (fbtn) {
      var block = fbtn.closest('.tpam-block');
      var type = fbtn.dataset.tpamFilter;
      block.querySelectorAll('[data-tpam-filter]').forEach(function (b) {
        b.classList.toggle('is-active', b === fbtn);
      });
      block.querySelectorAll('.tpam-card').forEach(function (c) {
        c.classList.toggle('is-hidden', type !== 'all' && c.dataset.type !== type);
      });
      return;
    }

    var btn = e.target.closest('[data-tpam-add]');
    if (!btn) return;
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.classList.contains('is-added') || btn.disabled) return;

    btn.disabled = true;
    btn.textContent = 'Wird hinzugefügt …';

    // IT#16397: B-Ware-Zustand als kundensichtbare Property "Zustand" mitstempeln
    var item = { id: parseInt(variantId, 10), quantity: 1 };
    if (btn.dataset.conditionProp) item.properties = { Zustand: btn.dataset.conditionProp };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        btn.disabled = false;
        btn.classList.add('is-added');
        btn.textContent = '✓ Im Warenkorb';
        refreshCount();
        refreshDrawerSection();
        // Spec 001: Zubehör per Quick-Add — läuft über rohes fetch, darum manuell
        // (kein CartLinesUpdateEvent → kein Doppelzählen mit add_to_cart).
        window.TP && TP.track('addon_added', { variant_id: variantId });
      })
      .catch(function (err) {
        console.error('[tpam] Quick-Add fehlgeschlagen:', err);
        btn.disabled = false;
        btn.textContent = '+ Hinzufügen';
      });
  });

  /* ---------- Trigger: Add des Hauptprodukts erkennen ----------
     Horizon führt den Add selbst aus. Wir merken uns beim Submit den Warenkorb-Stand
     (aus dem Badge) und pollen /cart.js, bis die Menge steigt. Dann Modal (oder – bei
     leerem Zubehör – Drawer als Fallback). */
  function currentBadgeCount() {
    var c = document.querySelector('.cart-bubble__text-count');
    var n = c ? parseInt((c.textContent || '').trim(), 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  // Poll /cart.js bis die Menge über den Ausgangswert steigt (= Add erfolgreich).
  // Resolve(true) bei Erfolg, resolve(false) bei Timeout/Fehler.
  function confirmAdd(baseline) {
    return new Promise(function (resolve) {
      var tries = 0;
      var MAX_TRIES = 12; // ~3 s
      (function poll() {
        fetch(CART_URL + '.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            if (cart.item_count > baseline) {
              updateBadge(cart.item_count);
              resolve(true);
              return;
            }
            if (++tries >= MAX_TRIES) {
              resolve(false);
              return;
            }
            setTimeout(poll, 250);
          })
          .catch(function () {
            resolve(false);
          });
      })();
    });
  }

  /* ---------- Trigger: Add des Hauptprodukts ----------
     Horizon führt den Add selbst aus. Wir öffnen das Modal SOFORT im Ladezustand
     (synchron zum Klick), sofern Zubehör existieren KÖNNTE, und prüfen den Add-Erfolg
     nur noch im Hintergrund. Schlägt der Add fehl -> Modal schließen. Kein Zubehör
     -> Modal zu, Drawer als Bestätigung. */
  var busy = false;
  function handleAtcSubmit() {
    if (busy) return;
    busy = true;
    var baseline = currentBadgeCount();

    var opened = false;
    if (!offersReady || offers.length > 0) {
      openModal();
      opened = true;
      if (offersReady) fillModal(offers);
    }

    Promise.all([offersPromise, confirmAdd(baseline)]).then(function (res) {
      busy = false;
      var list = res[0] || [];
      var ok = res[1];
      if (!ok) {
        if (opened) closeModal(); // Add fehlgeschlagen -> keine Bestätigung
        return;
      }
      refreshCount(); // Badge + Modal-Count auf den echten Stand
      if (list.length > 0) {
        if (!opened) openModal();
        fillModal(list);
      } else {
        if (opened) closeModal();
        openDrawerFallback(); // kein Zubehör -> Drawer als Bestätigung
      }
    });
  }

  // Submit der tp-Buybox abfangen (Capture, wie tp-add-to-cart.js) – nur ATC-Button,
  // NICHT PayPal / Express-Checkout.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!(form instanceof HTMLFormElement) || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      if (event.submitter && !event.submitter.matches('.tp-pdp__cta, [name="add"]')) return;
      handleAtcSubmit();
    },
    true
  );
})();
